
import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    Toolbar,
    InputAdornment,
    IconButton,
    Menu,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableSortLabel,
    TableContainer,
    TableHead,
    TableFooter,
    TableRow,
    TablePagination,
    Button,
    Drawer,
    TextField
} from "@mui/material";
import {ContainerClasses} from '../../themes/containerClasses';
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import CheckIcon from "@mui/icons-material/Check";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloseIcon from "@mui/icons-material/Close";
import CancelIcon from "@mui/icons-material/Cancel";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import {useTheme} from '@mui/material/styles';
import {ListViewModel,
        ListViewColumnModel,
        ListViewColumnFactory,
        ListViewFilterModel,
        RecordModel} from '../../models/models';
import {ListConfigurationModel,
        ListViewConfigurationModel} from "../../models/modelsListConfiguration";
import {ListViewUIPreferenceModel,
        ListViewUIPreferenceJSON,
        SortOrderModel,
        SortOrderFactory,
        SortDirectionType,
        BarChartUIPreferenceModel} from '../../models/modelsUserConfiguration';
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {SearchFieldComponent} from "../../components/searchField/SearchField";
import {CustomIconComponent} from "../../components/icons/CustomIcon";
import {ListFilterComponent} from "./ListFilter";
import {ListConfigurationComponent} from "./ListConfiguration";
import {useSnackbar} from "notistack";
import { formatDate, formatDatetime } from "../../utils/dateFunctions";
import {Link, useParams} from 'react-router-dom';
import {getAppName, getObjectName } from "../../utils/helperRouter";
import FilterListIcon from '@mui/icons-material/FilterList';
import {upsertListView} from "../../services/metadataApi";
import { useAuth } from "../../hooks/useAuth";



export const ListViewComponent: React.FC<{
  listView: ListViewModel,
  records: RecordModel[],
  listConfig: ListConfigurationModel,
  listViewConfig: ListViewConfigurationModel,
  switchPaginatorPage: (listViewConfig: ListViewConfigurationModel, newPage: number) => void,
  loadSortedRecords: (listViewConfig: ListViewConfigurationModel, sortOrders: SortOrderModel[]) => void,
  onDatabaseSearch: (listViewConfig: ListViewConfigurationModel) => void,
  onFrontendSearch: (listViewConfig: ListViewConfigurationModel) => void,
  onSave: (listView: ListViewModel) => void,
  selectRecord: (recordUuid: string) => void,
  context?: any
}> = ({
  listView,
  records,
  listConfig,
  listViewConfig,
  switchPaginatorPage,
  loadSortedRecords,
  onDatabaseSearch,
  onFrontendSearch,
  onSave,
  selectRecord,
  context = {}
}) => {

  const columnAlignment = 'left'

  const styles = ContainerClasses();
  const theme = useTheme();

  const {accessToken, onInvalidToken} = useAuth();
  let {appName, objectName, recordUuid} = useParams();

  const [rerender, setRerender] = useState<boolean>(false);
//  const [rowsPerPage, setRowsPerPage] = useState<number>(0);

  const [mutableRecords, setMutableRecords] = useState<RecordModel[]>(records);

  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    setMutableRecords(records)
  }, [listView.Uuid_sys,
      records.length,
      listViewConfig.paginator.recordCount])

/*
  useEffect(() => {
    setMutableListViewConfig(listViewConfig);
  }, [listViewConfig, listViewConfig.paginator.currentPage])
*/

  const getPaginationPage = () => {
    return listViewConfig.paginator.currentPage
  }


  const handleChangeRowsPerPage = (event: any) => {
    console.log('dynamic change of rows per page not implemented yet');
    return
  }

  const handleChangePage = (event: any, newPage: number) => {
    switchPaginatorPage(listViewConfig, newPage)
  }


  const sortFunction = (recordA: RecordModel,
                        recordB: RecordModel,
                        sortOrder: SortOrderModel) => {

    const fieldApiName = sortOrder.fieldApiName
    const sortDirection = sortOrder.sortDirection

    const fieldA = recordA.fields[fieldApiName]//recordA.fields.find((thisField) => thisField.fieldName === fieldApiName);
    const fieldB = recordB.fields[fieldApiName]//recordB.fields.find((thisField) => thisField.fieldName === fieldApiName);

    let sortIndex = 1

    if(sortDirection === 'asc'){
      fieldA?.fieldValue > fieldB?.fieldValue ? sortIndex=1 : sortIndex=-1
    }
    if(sortDirection === 'desc'){
      fieldA?.fieldValue > fieldB?.fieldValue ? sortIndex=-1 : sortIndex=1
    }

//    console.log(sortIndex, recordA.fields.LastModifiedDate_sys.fieldValue, recordB.fields.LastModifiedDate_sys.fieldValue)

    return sortIndex

  }


  const handleSort = (event: any, column: ListViewColumnModel) => {

//    setPaginationPage(0);

    const currentSortOrder = getCurrentSortOrder(column)
    let newSortDirection = 'asc' as SortDirectionType;
    if(currentSortOrder && currentSortOrder.sortDirection === 'asc'){
      //if exists, change sort direction
      newSortDirection='desc' as SortDirectionType;
    }
    const newSortOrder = new ListViewColumnFactory().toSortOrder(column, 1, newSortDirection)

    //FOR NOW: ALWAYS MAKE SORTING PERSISTENT IN BACKEND DATABASE
    //ALSO; reset paginator
    const newConfig = {
      ...listViewConfig,
      paginator: {...listViewConfig.paginator,
                  currentPage: 0},
      }
    loadSortedRecords(newConfig, [newSortOrder])
  }

  const handleDatabaseSearch = () => {
    const newConfig = {
      ...listViewConfig,
      paginator: {...listViewConfig.paginator,
                  currentPage: 0},
      searchTerm: {...listViewConfig.searchTerm,
                   backendSearchPerformed: true}
      }
    onDatabaseSearch(newConfig);
  }


  const handleSearch = (searchText: string) => {

    //first, need to reset pagination
    const thisSearchText = searchText.toLowerCase();

    const filterTypes = ["string", "number"]

    const cloneRecords = records.filter((thisRecord) => {

      const keys = Object.keys(thisRecord.fields);
      const fieldValuesFound = keys.filter((thisKey) => {
        const thisField = thisRecord.fields[thisKey];
        if(filterTypes.includes(typeof(thisField.fieldValue)) &&
           thisField.fieldValue.toString().toLowerCase().includes(thisSearchText)){
             return 1
           }
         })
      if(fieldValuesFound.length > 0){
        return thisRecord
      }
    })

    const newConfig = {
      ...listViewConfig,
      paginator: {...listViewConfig.paginator,
                  currentPage: 0},
      searchTerm: {...listViewConfig.searchTerm,
                   searchText: searchText}
      }
    onFrontendSearch(newConfig);
    setMutableRecords(cloneRecords);
  }


  const clearSearch = () => {
    //if backend search already performed: reset search with new database request
    if(listViewConfig.searchTerm.backendSearchPerformed === true){
      const newConfig = {
        ...listViewConfig,
        paginator: {...listViewConfig.paginator,
                    currentPage: 0,
                    loadedPages: [0]},
        searchTerm: {...listViewConfig.searchTerm,
                     searchText: ""}
      }
      onDatabaseSearch(newConfig);
    } else {
      //simply use a "frontend search" with empty string
      handleSearch("")
    }
  }

  const handleLinkClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    //need to stop clicking "button" which is the complete row
    //when clicking a link
    event.stopPropagation();
  }

  const rowElement = (record: RecordModel) => {

    const recordFields = record.fields;
    const recordUuidField = recordFields["Uuid_sys"]

    var linkSet = false;

    const handleRowClick = (event: React.MouseEvent<HTMLTableRowElement>)=>{
      //allow selecting of text within row
      const selectedText = window.getSelection()?.toString();
      if(selectedText && selectedText.length > 0) {
        event.stopPropagation();
        return;
      }
      selectRecord(recordUuidField?.fieldValue)
    }

    return (
      <TableRow
         key={recordUuidField?.fieldValue}
         hover
         onClick={handleRowClick}
      >
         { listView.listview_columns.map((thisColumn) => {
           const columnFieldName = thisColumn.ReferencedField_sys.ApiName_sys
           const currentField = recordFields[columnFieldName]

           if(currentField === null || currentField === undefined){
             return (
                  <TableCell  key={`${recordUuidField?.fieldValue} - ${thisColumn.Uuid_sys}`} scope="row" align={columnAlignment}>
                     undefined
                  </TableCell>
                )
           }

           const currentFieldType = currentField.fieldType

           if(currentFieldType === 'ForeignKey'){
             if(currentField.fieldValue){
               const lookup_object_name = currentField.fieldValue.lookup_object;
               const lookup_uuid = currentField.fieldValue.Uuid_sys;
               const appApiName = getAppName(appName)
               const link_to = '/' + appApiName + '/' + lookup_object_name + '/' + lookup_uuid;
               return (
                  <TableCell key={`${recordUuidField?.fieldValue} - ${thisColumn.Uuid_sys}`} scope="row" align={columnAlignment}>
                    <Link to={link_to} onClick={handleLinkClick}>
                      {currentField.fieldValue.lookup_display_value}
                    </Link>
                  </TableCell>
                )
             }
             return (
                  <TableCell key={`${recordUuidField?.fieldValue} - ${thisColumn.Uuid_sys}`} scope="row" align={columnAlignment}>
                  </TableCell>
                )
           }

           if(currentFieldType === 'OneToOneField'){
             if(currentField.fieldValue){
               const lookup_object_name = currentField.fieldValue.lookup_object;
               const lookup_uuid = currentField.fieldValue.Uuid_sys;
               const appApiName = getAppName(appName)
               const link_to = '/' + appApiName + '/' + lookup_object_name + '/' + lookup_uuid;
               return (
                  <TableCell key={`${recordUuidField?.fieldValue} - ${thisColumn.Uuid_sys}`} scope="row" align={columnAlignment}>
                    <Link to={link_to} onClick={handleLinkClick}>
                      {currentField.fieldValue.lookup_display_value}
                    </Link>
                  </TableCell>
                )
             }
             return (
                  <TableCell key={`${recordUuidField?.fieldValue} - ${thisColumn.Uuid_sys}`} scope="row" align={columnAlignment}>
                  </TableCell>
                )
           }

           if(currentFieldType === 'DateTimeField'){
             const thisValue = formatDatetime(new Date(currentField?.fieldValue), {variant: 'D'})
             return(
               <TableCell key={`${recordUuidField?.fieldValue} - ${thisColumn.Uuid_sys}`} scope="row" align={columnAlignment}>
                 {thisValue}
               </TableCell>
             )
           }

           if(currentFieldType === 'FormulaField'){
             //for now, always stringify formulas and treat as JSON
             //maybe adjust in future
             const thisValue = JSON.stringify(currentField?.fieldValue, null, 2)
             return (
               <TableCell  key={`${recordUuidField?.fieldValue} - ${thisColumn.Uuid_sys}`} scope="row" align={columnAlignment}>
                 {thisValue}
               </TableCell>
             )
           }

           if(linkSet === false){
             //default
             linkSet=true;
             let link_to = recordUuidField.fieldValue;
             if(context?.lookupObjectName) {
               const lookupObjectName = context.lookupObjectName;
               const lookupUuid = currentField.fieldValue.Uuid_sys;
               const appApiName = getAppName(appName)
               link_to = '/' + appApiName + '/' + lookupObjectName + '/' + recordUuidField.fieldValue;
           }

             return (
               <TableCell key={`${recordUuidField?.fieldValue} - ${thisColumn.Uuid_sys}`} scope="row" align={columnAlignment}>
                  <Link to={link_to} onClick={handleLinkClick}>
                     {currentField?.fieldValue}
                  </Link>
               </TableCell>
             )
           }

           if(currentFieldType === 'BooleanField'){
             return(
               <TableCell key={`${recordUuidField?.fieldValue} - ${thisColumn.Uuid_sys}`} scope="row" align={columnAlignment}>
                 {currentField.fieldValue === true  &&
                   <CheckCircleIcon sx={{color: theme.extras.boolTrue}}/>
                 }
                 {/*
                   <CancelIcon sx={{color: theme.extras.boolFalse}}/>
                 */}
               </TableCell>
             )
           }

           if(currentFieldType === 'JSONField'){
             const thisValue = JSON.stringify(currentField?.fieldValue, null, 2)
             return(
               <TableCell key={`${recordUuidField?.fieldValue} - ${thisColumn.Uuid_sys}`} scope="row" align={columnAlignment}>
                 {thisValue}
               </TableCell>
             )
           }

           if(currentFieldType === 'FileField'){
             return(
               <TableCell key={`${recordUuidField?.fieldValue} - ${thisColumn.Uuid_sys}`} scope="row" align={columnAlignment}>
                 {currentField.fieldValue?.filename}
               </TableCell>
             )
           }

           return (
             <TableCell key={`${recordUuidField?.fieldValue} - ${thisColumn.Uuid_sys}`} scope="row" align={columnAlignment}>
                 {currentField.fieldValue}
             </TableCell>
           )


         })}

      </TableRow>
    )
  }

  const getCurrentSortOrder = (listviewColumn: ListViewColumnModel) => {
    if(listView.user_preference){
      const sortOrder = listView.user_preference.sortColumns.find((thisSortOrder: SortOrderModel) => thisSortOrder.sortColumnUuid === listviewColumn.Uuid_sys)
      return sortOrder
    }
    return undefined
  }

  return (

    <Box>
       <Box sx={{flex: 1,
                 display: "flex",
                 flexDirection: "row",
                 justifyContent: "flex-end",
                 alignItems: "center"}}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2
            }}
          >
            <SearchFieldComponent
              searchText={listViewConfig.searchTerm.searchText}
              setSearchText={handleSearch}
              clearSearchText={clearSearch}
              onDatabaseSearch={handleDatabaseSearch}
            />
            <TablePagination
              rowsPerPageOptions={[listViewConfig.paginator.pageSize]}
              count={listViewConfig.paginator.recordCount}
              rowsPerPage={listViewConfig.paginator.pageSize}
              page={getPaginationPage()}
              onPageChange={(event, newPage) => handleChangePage(event, newPage)}
              onRowsPerPageChange={(event) => handleChangeRowsPerPage(event)}
            />
          </Box>
        </Box>

        <TableContainer sx={{maxHeight: 650, width: '100%'}}>

           <Table stickyHeader sx={{minWidth: 650}}>
              <TableHead>
                 <TableRow>
                    {listView.listview_columns.map((column) => {
                           const thisIcon = column.ReferencedField_sys.ReferencedObject_sys?.ReferencedIcon_sys;
                           const currentSortOrder = getCurrentSortOrder(column)

                           return (
                                <TableCell
                                    key={column.Uuid_sys}
                                    align={columnAlignment}
                                >
                                    <TableSortLabel
                                       active={currentSortOrder !== undefined}
                                       direction={currentSortOrder?.sortDirection}
                                       onClick={(event) => handleSort(event, column)}
                                       >
                                    <Typography style={{fontWeight: 'bold'}}>
                                       {column.ReferencedField_sys.Label_sys}
                                    </Typography>
                                    {thisIcon &&
                                      <CustomIconComponent
                                        icon={thisIcon}
                                        sx={{
                                          marginLeft: '0.2rem'
                                        }}
                                      />
                                    }
                                    </TableSortLabel>
                                </TableCell>
                              )
                            })}
                  </TableRow>
              </TableHead>

              <TableBody>
                 {mutableRecords.slice(getPaginationPage()*listViewConfig.paginator.pageSize, getPaginationPage()*listViewConfig.paginator.pageSize + listViewConfig.paginator.pageSize)
                                  .map((record) => rowElement(record))}
                 {/*mutableRecords.slice(paginator.currentPage*paginator.pageSize, paginator.currentPage*paginator.pageSize + paginator.pageSize)
                                  .map((record) => rowElement(record))*/}
                 {/*mutableRecords.map((record) => rowElement(record))*/}
              </TableBody>

              <TableFooter>
                <TableRow>
                  <TablePagination
                    rowsPerPageOptions={[listViewConfig.paginator.pageSize]}
                    count={listViewConfig.paginator.recordCount}
                    rowsPerPage={listViewConfig.paginator.pageSize}
                    page={getPaginationPage()}
                    onPageChange={(event, newPage) => handleChangePage(event, newPage)}
                    onRowsPerPageChange={(event) => handleChangeRowsPerPage(event)}
                  />
                </TableRow>
              </TableFooter>


            </Table>
        </TableContainer>

    </Box>
  );

};
